import React, {useEffect, useRef, useState} from "react";
import {
    Alert,
    Button,
    Col,
    DatePicker,
    Divider,
    Form,
    Input, Radio,
    Row,
    Select,
} from "antd";
import dayjs from "dayjs";
import {IoCheckmarkCircle} from "react-icons/io5";
import {userService} from "../../services/user.service";
import {useSelector} from "react-redux";
import {MessageSuccess} from "../../components/messageSuccess/messageSuccess";
import {FileUploader} from "../../components/fileUploader/fileUploader";
import {ConvertBlogToFile} from "../../utils/ProfileFunctions";
import { LoginProviderTypes } from "../../enums/LoginProviderTypes";
export const FormUserProfileEdit = ({
    isModalOpen,
    showFormUserProfile,
    profileInfo,
    handleUpdateProfile
}) => {
    const [form] = Form.useForm();
    const [currentDate] = useState(dayjs().subtract(18, "years"));
    const [user, setUser] = useState({
        firstName: null,
        lastName: null,
        birthday: null,
        pronoun: null,
        nickname: null,
        urlProfileImage: null,
        currentPassword: null,
        newPassword: null
    });
    const companyId = useSelector((state) => state.userSettings.companyId);
    const [password, setPassword] = useState("");
    const [changePassword, setChangePassword] = useState(false);
    const oneCharacter = useRef();
    const oneN = useRef();
    const oneLetterL = useRef();
    const oneLetterU = useRef();
    const min8Characters = useRef();
    const [validatePassword, setValidatePassword] = useState(false);
    const [updatedProfile, setUpdatedProfile] = useState(false);
    const [file,setFile] = useState("");
    const [isUserFromGoogle,setIsUserFromGoogle] = useState(true);
    const [messageSuccess, setMessageSuccess] = useState({
        title: "",
        description: "",
        status: false,
    });

     const onSubmit = async () => {
            try {
                const response = await userService.editProfile(user,companyId);
                if (response.success) {
                    setUpdatedProfile(true);
                    setMessageSuccess({
                        title: response.msg,
                        description: "",
                        status: true
                    })
                    handleUpdateProfile();
                    return setTimeout(() => setUpdatedProfile(false), 4000);
                } else {
                    setUpdatedProfile(true);
                    setMessageSuccess({
                        title: response.msg,
                        description: "Vuelve a intentarlo, por favor",
                        status: false
                    })
                    return setTimeout(() => setUpdatedProfile(false), 4000);
                }
            } catch (error) {
                console.error('Error en el registro:', error);
            }
        };
    

    const handleInputValue = (e) => setUser({ ...user, [e.target.name]: e.target.value });

    const handleSelectPronoun = (value) => setUser({ ...user, pronoun: value });

    const handleBirthday = (_str, _date) => setUser({ ...user, birthday: _date });

    const handleDisabledDate = (current) => {
        return dayjs().subtract(18, "years") < current;
    };

    const handlePassword = (e) => {
        const oneLetterUppercase = /.*[A-Z].*/;
        const oneLetterLowercase = /.*[a-z].*/;
        const oneNumber = /.*[0-9].*/;
        const oneSpecialCharacter =
            /(.*[!@#$%\^&*(){}[\]<>?/|-]+|.*[!@#$%\^&*(){}[\]<>?/|\-]+)/;

        const noSpace = e.target.value.replace(/ /g, "");

        if (String(noSpace).length >= 8)
            min8Characters.current.className = "success";
        else min8Characters.current.className = "";

        if (oneLetterUppercase.test(noSpace))
            oneLetterU.current.className = "success";
        else oneLetterU.current.className = "";

        if (oneLetterLowercase.test(noSpace))
            oneLetterL.current.className = "success";
        else oneLetterL.current.className = "";

        if (oneNumber.test(noSpace)) oneN.current.className = "success";
        else oneN.current.className = "";

        if (oneSpecialCharacter.test(noSpace))
            oneCharacter.current.className = "success";
        else oneCharacter.current.className = "";

        form.setFieldValue("newPassword", noSpace);
        setUser({... user, newPassword: noSpace});
    };

    const handleFileSelected = (file) => setUser({ ...user, urlProfileImage:file });

    const handleFileRemoved = (file) => {
        setUser({ ...user, urlProfileImage: null });
        setFile("");
    }

    const handleCleanForm = () => {
        setUser({
            firstName: null,
            lastName: null,
            birthday: null,
            pronoun: null,
            nickname: null,
            urlProfileImage: null,
            currentPassword: null,
            newPassword: null
        });
        form.resetFields();
        handleLoadImage();

    }

    const handleLoadImage = async () => {
        const fileConverted = await  ConvertBlogToFile(profileInfo?.urlProfileImage);
        setFile(fileConverted);
    }

    useEffect(() => {
        if (isModalOpen) {
            form.setFieldsValue({
                firstName: profileInfo.firstName,
                lastName: profileInfo?.lastName,
                birthday: dayjs(profileInfo.birthday),
                pronoun:  profileInfo?.pronoun,
                nickname: profileInfo?.nickname
            });
           handleLoadImage();
        }
        if(profileInfo.loginProvider !== 3)
            setIsUserFromGoogle(false)
    }, [isModalOpen]);

    useEffect(()=> {
        if(!changePassword)
            setPassword("")
    },[changePassword]);

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            className="form-light fixed"
        >
            {
                (updatedProfile) ?
                    <MessageSuccess
                        title={messageSuccess.title}
                        description={messageSuccess.description}
                        handleButtonClick={() => setUpdatedProfile(false)}
                        isSuccess={messageSuccess.status}
                    />
                    :

                    <Row gutter={[16, 8]}>
                        <Col xs={24}>
                            <div className="form-light__title">
                                <h4>Edita tu perfil</h4>
                                <Divider orientation="center">Información personal</Divider>
                            </div>
                        </Col>

                        <Col sm={12} xs={24}>
                            <Form.Item
                                label="Escribe tu nombre"
                                name="firstName"
                                rules={[{ required: true, message: "*Campo requerido" }]}
                                onChange={handleInputValue}
                            >
                                <Input size="large"  name="firstName" />
                            </Form.Item>
                        </Col>

                        <Col sm={12} xs={24}>
                            <Form.Item
                                label={"Tu apellido"}
                                name="lastName"
                                htmlFor={"lastName"}
                                rules={[{ required: true, message: "*Campo requerido" }]}
                                onChange={handleInputValue}
                            >
                                <Input size="large" name="lastName" />
                            </Form.Item>
                        </Col>

                        <Col sm={12} xs={24}>
                            <Form.Item
                                label="Tu cumpleaños"
                                name="birthday"
                                rules={[
                                    { required: true, message: "*Campo requerido" },
                                    {
                                        validator: (_, value) => {
                                            if (!value) return Promise.resolve();
                                            return dayjs().diff(value, "years") >= 18
                                                ? Promise.resolve()
                                                : Promise.reject("Debes tener al menos 18 años");
                                        }
                                    }
                                ]}
                            >
                                <DatePicker
                                    size="large"
                                    placeholder="Selecciona una fecha"
                                    picker="date"
                                    format="DD/MMM/YYYY"
                                    showToday={false}
                                    name="birthday"
                                    onChange={handleBirthday}
                                    onFocus={() => {
                                        form.setFieldValue("birthday", currentDate);
                                        setUser({ ...user, birthday: currentDate });
                                    }}
                                    disabledDate={handleDisabledDate}
                                />
                            </Form.Item>
                        </Col>
                        {(profileInfo.loginProvider == LoginProviderTypes.PASSWORD || profileInfo.loginProvider == null) && (
                            <Col sm={12} xs={24}>
                                <Form.Item
                                    label="Contraseña"
                                >
                                    <Button htmlType={"button"} type={"primary"} block={true} onClick={() => setChangePassword(!changePassword)}>Cambiar contraseña</Button>
                                </Form.Item>
                            </Col>
                        )}
                        {
                            (changePassword) && (
                                <>
                                    <Col sm={12} xs={24}>
                                        <Form.Item
                                            label={"Contraseña actual"}
                                            name={"currentPassword"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "*Campo requerido",
                                                },
                                            ]}
                                            onChange={handleInputValue}
                                        >
                                            <Input.Password name={"currentPassword"} size={"large"} />
                                        </Form.Item>
                                    </Col>
                                    
                                    <Col sm={12} xs={24}>
                                        <Form.Item
                                            label={"Nueva contraseña"}
                                            htmlFor={"newPassword"}
                                            name={"newPassword"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "*Campo requerido",
                                                },
                                                {
                                                    min: 8,
                                                    message: "",
                                                },
                                                {
                                                    pattern: new RegExp(/.*[A-Z].*/),
                                                    message: "",
                                                },
                                                {
                                                    pattern: new RegExp(/.*[a-z].*/),
                                                    message: "",
                                                },
                                                {
                                                    pattern: new RegExp(/.*[0-9].*/),
                                                    message: "",
                                                },
                                                {
                                                    pattern: new RegExp(
                                                        /(.*[!@#$%\^&*(){}[\]<>?/|-]+|.*[!@#$%\^&*(){}[\]<>?/|\-]+)/
                                                    ),
                                                    message: "",
                                                },
                                            ]}
                                            onChange={handlePassword}
                                        >
                                            <Input.Password
                                                name={"newPassword"}
                                                size={"large"}
                                                onBlur={() => setValidatePassword(false)}
                                                onFocus={() => setValidatePassword(true)}
                                            />
                                        </Form.Item>
                                        <div
                                            className={`msg-password`}
                                        >
                                            <ul className={"msg-password__list"}>
                                                <li>
                                        <span ref={min8Characters}>
                                          <IoCheckmarkCircle />
                                        </span>
                                                    Mínimo 8 carácteres
                                                </li>
                                                <li>
                                        <span ref={oneLetterU}>
                                          <IoCheckmarkCircle />
                                        </span>
                                                    1 letra mayúscula
                                                </li>
                                                <li>
                                        <span ref={oneLetterL}>
                                          <IoCheckmarkCircle />
                                        </span>
                                                    1 letra minúscula
                                                </li>
                                                <li>
                                        <span ref={oneN}>
                                          <IoCheckmarkCircle />
                                        </span>
                                                    1 número
                                                </li>
                                                <li>
                                        <span ref={oneCharacter}>
                                          <IoCheckmarkCircle />
                                        </span>
                                                    1 carácter especial
                                                </li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col sm={12} xs={24}>
                                        <Form.Item
                                            label={"Confirma tu contraseña"}
                                            name={"confirmPassword"}
                                            dependencies={["newPassword"]}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "",
                                                },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (!value || getFieldValue("newPassword") === value) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(
                                                            new Error("¡Las contraseñas no coinciden!")
                                                        );
                                                    },
                                                }),
                                            ]}
                                        >
                                            <Input.Password name={"confirmPassword"} size={"large"} />
                                        </Form.Item>
                                    </Col>
                                </>
                            )
                        }

                        <Col sm={12} xs={24}>
                            <Form.Item
                                label="Me identifico como..."
                                name="pronoun"
                                htmlFor={"pronoun"}
                                rules={[{ required: true, message: "*Campo requerido" }]}
                            >
                                <Select size="large" onChange={handleSelectPronoun}>
                                    <Select.Option value={"Él"}>Él</Select.Option>
                                    <Select.Option value={"Ella"}>Ella</Select.Option>
                                    <Select.Option value={"Elle"}>Elle</Select.Option>
                                    <Select.Option value={"Otro"}>Otro</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={12} xs={24}>
                            <Form.Item
                                label={"Tu nickname"}
                                name="nickname"
                                htmlFor={"nickname"}
                                onChange={handleInputValue}
                            >
                                <Input size="large" name="nickname" />
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Divider orientation="center">Foto de perfil</Divider>
                        </Col>
                        {

                            (!isUserFromGoogle) ?
                                <Col xs={24}>
                                    <Form.Item
                                        label={"Sube tu foto de perfil"}
                                        name={"urlProfileImage"}
                                        htmlFor={"urlProfileImage"}
                                    >
                                        <FileUploader
                                            onFilesSelected={handleFileSelected}
                                            fieldName={"urlProfileImage"}
                                            onDeleteFiles={handleFileRemoved}
                                            updateFiles={(file !== "") ? [file] : []}
                                            acceptFiles={["image/png", "image/jpeg", "image/webp", "image/jpg"]}
                                        />
                                    </Form.Item>
                                </Col>
                                :
                                <Col xs={24}>
                                    <Form.Item
                                        label={"Sube tu foto de perfil"}
                                    >
                                        <Alert
                                            type={"info"}
                                            showIcon={true}
                                            message={"¡Ups!"}
                                            closable={true}
                                            description={"No puedes subir otra foto de perfil porque creaste tu cuenta con un proveedor externo."}
                                        />
                                    </Form.Item>
                                </Col>
                        }
                        <div className="form-light__footer fixed">
                            <Button
                                htmlType="button"
                                type="default"
                                block
                                onClick={() => showFormUserProfile(false)}
                            >
                                Cerrar
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                block
                            >
                                Guardar
                            </Button>
                        </div>
                    </Row>
            }
        </Form>
    );
};
